<template>
  <section class="aviation-career-section" v-if="$route.name === 'ACGuidance'">
    <base-info-bar>
      <router-link to="/training-services/pilot-training">{{ getMenuInfo.name }}</router-link>
      <span><img @contextmenu.prevent src="../../assets/spacer.png"><img @contextmenu.prevent src="../../assets/spacer.png">
        >
        <img @contextmenu.prevent src="../../assets/spacer.png"><img @contextmenu.prevent src="../../assets/spacer.png"></span>
      <router-link :to="getSubMenuInfo.url" style="color: black;">{{ getSubMenuInfo.name }}</router-link>
    </base-info-bar>

    <TrainingServicesContent :subMenu="getSubMenu"></TrainingServicesContent>
  </section>

  <router-view></router-view>

</template>

<script>
import TrainingServicesContent from '@/components/training-services/TrainingServicesContent.vue'
export default {
  components: {
    TrainingServicesContent
  },
  computed: {
    getSubMenu () {
      if (this.$store.state.lang === 'vn') {
        return 12
      } else {
        return 31
      }
    },
    getMenuInfo () {
      return this.$store.getters['navbar/finalMenu'][2]
    },
    getSubMenuInfo () {
      return this.$store.getters['navbar/findSubMenus1'](this.getSubMenu)
    }
  }
}
</script>

<style scoped>
.aviation-career-section a {
  text-decoration: none;
  color: rgb(28, 108, 193);
  font-weight: 700;
}

.aviation-career-section span{
  font-weight: 800;
}
</style>
